<template>
  <div class="portal-page oauth-kakao">
    <div class="portal-page__inner oauth-kakao__shell">
      <p class="oauth-kakao__title">카카오 확인 중</p>
      <p class="oauth-kakao__desc">{{ message }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { completeMemberKakaoOAuth } from '@/api/member'
import { applyMemberHomeAfterLogin } from '@/composables/useLoginDestination'
import { useMemberAuth } from '@/composables/useMemberAuth'
import { saveAutoLogin } from '@/constants/autoLogin'

const route = useRoute()
const router = useRouter()
const { setMember } = useMemberAuth()
const message = ref('카카오 계정 확인을 기다리고 있습니다.')

const fail = async (text: string) => {
  window.alert(text)
  await router.replace({ path: '/login' })
}

onMounted(async () => {
  const error = typeof route.query.error === 'string' ? route.query.error : ''
  if (error === 'access_denied') {
    await fail('카카오 로그인을 취소했습니다.')
    return
  }
  if (error) {
    await fail('카카오 로그인에 실패했습니다. 다시 눌러 주세요.')
    return
  }

  const code = typeof route.query.code === 'string' ? route.query.code : ''
  const state = typeof route.query.state === 'string' ? route.query.state : ''
  if (!code || !state) {
    await fail('카카오 로그인 정보가 없습니다. 다시 눌러 주세요.')
    return
  }

  try {
    const result = await completeMemberKakaoOAuth({ code, state })
    if (result.action === 'login' && result.member) {
      saveAutoLogin('member', true)
      setMember(result.member)
      const home = applyMemberHomeAfterLogin()
      await router.replace(result.redirect || home)
      return
    }

    if (result.action === 'signup') {
      await fail('카카오 가입을 이어서 처리하지 못했습니다. 다시 눌러 주세요.')
      return
    }

    await fail('카카오 로그인 결과를 확인할 수 없습니다.')
  } catch (caught) {
    await fail(caught instanceof Error ? caught.message : '카카오 로그인에 실패했습니다.')
  }
})
</script>

<style lang="scss" src="./OAuthKakaoPage.scss"></style>
